import {Board, Footer} from "../components";
import React from "react";

export default function HomePage() {
    return (
        <div>
            <Board/>
            <Footer/>
        </div>
    )
}
